export default "__VITE_ASSET__2dbd90a4__"